import type { ReactNode } from 'react';

/**
 * ⭐ "Nothing matched" — and ONLY that. This component takes no error prop, so it is structurally
 * incapable of standing in for a failure. The distinction the spec asks for is enforced by the type
 * system rather than by remembering to make it.
 */
export function EmptyState({
  title,
  detail,
  action,
}: {
  title: string;
  detail?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-14 text-center">
      <p className="text-base font-semibold text-[color:var(--color-ink)]">{title}</p>
      {detail ? (
        <p className="max-w-sm text-sm text-[color:var(--color-ink-muted)]">{detail}</p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
